import { ExamCenterMemberList } from '@exam-center/exam-center-member-list';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Box, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ExamCenterMemberListPage() {
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.EXAM_CENTER_MANAGEMENT.MEMBER.VIEW}>
      <PaperSection title='สมาชิก' sx={{ height: '100%' }}>
        <Box sx={{ p: (theme) => theme.spacing(6), height: '100%' }}>
          <ExamCenterMemberList />
        </Box>
      </PaperSection>
    </PermissionGuard>
  );
}
